import globals from "./globals";
import $ from "cash-dom";
import { gsapTrigger as WyPt } from "Utilities";

const component = (function () {
    $(document).ready(function () {
        if ($(".scroll-trigger").length) {
            if (globals.debug) console.log("component-scroll-trigger initialized");
            $(".scroll-trigger").each(function () {
                new WyPt({
                    element: $(this).find(".keyframes")[0],
                    offset: {
                        top: "top-top",
                        bottom: "bottom-top",
                    },
                    callback: {
                        enter: function (_el) {
                            var scrollTrigger = $(_el).parents(".scroll-trigger");
                            scrollTrigger.addClass("in-view");
                        },
                        leave: function (_el) {
                            var scrollTrigger = $(_el).parents(".scroll-trigger");
                            scrollTrigger.removeClass("in-view");

                            if (scrollTrigger.hasClass("layout-panning-image")) {
                                var image = scrollTrigger.find(".panning-image-element .source-image")[0];

                                image.style.transformOrigin = `50 50`;
                                image.style.transform = `scale(1)`;
                            }
                        },
                    },
                    // pointMode: true,
                });
            });
        }
    });
})();

export default component;
